<div class="contentHeight">
  <h1 class="text-center containerTitle" [translate]="'rentinglist.listRenting'"></h1>
  <div class="row mx-auto adminContent">
    <!-- Tableau principal -->
    <div class="col-xl-8 col-lg-8 col-md-12 mx-auto">
      <div class="table-wrapper-scroll-y noOverflow">
        <mat-table class="table bg-white respTab table-hover" [dataSource]="rentingLst" matSort (matSortChange)="sortScale($event,'1')">
          <!-- Identifiant de la demande -->
          <ng-container matColumnDef="rentingId">
            <mat-header-cell *matHeaderCellDef mat-sort-header><span [translate]="'rentinglist.numero'"></span></mat-header-cell>
            <mat-cell *matCellDef="let res">{{res.rentingID}}</mat-cell>
          </ng-container>
          <!-- Statut de l'activation -->
          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef mat-sort-header><span [translate]="'activlist.statut'"></span></mat-header-cell>
            <mat-cell *matCellDef="let res">
              <div *ngIf="res.status == 0" matTooltip="{{'rentinglist.statut0'|translate}}">
                <i  aria-hidden="true" class="fad fa-hourglass-half fa-2x twoToneBlue"></i>
              </div>
              <div *ngIf="res.status == 1" matTooltip="{{'rentinglist.statut1'|translate}}">
                <i  aria-hidden="true" class="fad fa-check fa-2x twoToneGreen"></i>
              </div>
              <div *ngIf="res.status == 2" matTooltip="{{'rentinglist.statut2'|translate}}">
                <i  aria-hidden="true" class="fad fa-ban fa-2x twoToneRed"></i>
              </div>
              <div *ngIf="res.status == 3" matTooltip="{{'rentinglist.statut3'|translate}}">
                <i  aria-hidden="true" class="fad fa-trash-alt fa-2x twoToneOrange"></i>
              </div>
            </mat-cell>
          </ng-container>
          <!-- Date de la demande de location -->
          <ng-container matColumnDef="rentingDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header><span [translate]="'rentinglist.rentingDate'"></span></mat-header-cell>
            <mat-cell *matCellDef="let res">{{ res.rentingDate | date:'dd/MM/yyyy' }}</mat-cell>
          </ng-container>
          <!-- Date de traitement -->
          <ng-container matColumnDef="treatmentDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header><span [translate]="'rentinglist.treatmentDate'"></span></mat-header-cell>
            <mat-cell *matCellDef="let res">{{ res.treatmentDate | date:'dd/MM/yyyy' }}</mat-cell>
          </ng-container>
          <!-- Raison sociale de la compagnie -->
          <ng-container matColumnDef="companySocialReason">
            <mat-header-cell *matHeaderCellDef mat-sort-header><span [translate]="'scaleform.raisonsociale'"></span></mat-header-cell>
            <mat-cell *matCellDef="let res">{{ res.companySocialReason }}</mat-cell>
          </ng-container>
          <!-- Icone pour ouvrir la modale donnant + d'informations -->
          <ng-container matColumnDef="info">
            <mat-header-cell *matHeaderCellDef><span [translate]="'activlist.info'"></span></mat-header-cell>
            <mat-cell *matCellDef="let res">
              <i  aria-hidden="true" class="far fa-search-plus fa-2x pointer" (click)="displayInfoRenting(res.rentingID)"></i>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
    </div>
  </div>

  <!-- Modal - Informations -->
  <div id="infos" class="modal">
    <div class="modal-content">
      <div class="col-12 text-center">
        <span class="text-right pointer close" (click)="closeModal('infos')">
          <i  aria-hidden="true" class="fal fa-times fa-1x5 primaryRed"></i>
        </span>
        <h1 [translate]="'rentinglist.detail'"></h1>
      </div>
      <div class="mr-3 ml-3 row" *ngFor="let info of dataInfo">
        <div class="row mx-auto col-xl-6 col-lg-6">
          <!-- Informations société -->
          <div class="col-xl-6 col-lg-12 col-md-6 mb-2">
            <hr>
            <h3>
              <i  aria-hidden="true" class="fad fa-address-card twoToneLightGreen fa-1-2x titleIcon"></i>
              <span class="breakWord" [translate]="'register.companyInfo'"></span>
            </h3>
            <div class="row">
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'renting.leader'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.leader }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'renting.bodyshopInterlocutor'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.bodyshopInterlocutor }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'scaleform.mobile'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.companyPhone }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'scaleform.telephone'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.companyDirectLign }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'scaleform.mail'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.companyMail }}
              </div>
            </div>
          </div>
          <!-- Contact société -->
          <div class="col-xl-6 col-lg-12 col-md-6 mb-2">
            <hr>
            <h3>
              <i  aria-hidden="true" class="fad fa-industry-alt twoToneGreen fa-1-2x titleIcon"></i>
              <span class="breakWord" [translate]="'renting.societyContact'"></span>
            </h3>
            <div class="row">
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'scaleform.raisonsociale'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.companySocialReason }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'scaleform.adresse'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.companyAddress }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'scaleform.codepostal'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.companyPostalCode }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'scaleform.ville'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.companyCity }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'scaleform.pays'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.companyCountry }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'renting.siren'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.companySiren }}
              </div>
            </div>
          </div>
          <!-- Activité client -->
          <div class="col-xl-6 col-lg-12 col-md-6 mb-2">
            <hr>
            <h3>
              <i  aria-hidden="true" class="fad fa-id-card-alt twoToneBlue fa-1-2x titleIcon"></i>
              <span class="breakWord" [translate]="'renting.customerActivity'"></span>
            </h3>
            <div class="row">
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'renting.customerIxellNumber'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.ixellAccount }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'renting.tarif'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.customerStatus }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'common.technology'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.technology }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'renting.companyType'"></span>
                <span class="font-weight-bold"> : </span>
                <span *ngIf="info.companyType == 'reseau'" [translate]="'renting.reseau'"></span>
                <span *ngIf="info.companyType == 'enseigne'" [translate]="'renting.enseigne'"></span>
                <span>&nbsp;</span>
                <span *ngIf="info.companyTypeName">({{ info.companyTypeName }})</span>
              </div>
            </div>
          </div>
          <!-- Informations CT -->
          <div class="col-xl-6 col-lg-12 col-md-6 mb-2">
            <hr>
            <h3>
              <i  aria-hidden="true" class="fad fa-user-hard-hat twoToneLightBlue fa-1-2x titleIcon"></i>
              <span class="breakWord" [translate]="'renting.infoCt'"></span>
            </h3>
            <div class="row">
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'renting.ctIxell'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.ctcFirstname }} {{ info.ctcName}}
              </div>
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'renting.ctPhone'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.ctcPhone }}
              </div>
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'renting.ctMail'"></span>
                <span class="font-weight-bold"> : </span>
                {{ info.ctcMail }}
              </div>
            </div>
          </div>
          <!-- Offre commerciale -->
          <div class="col-xl-6 col-lg-12 col-md-6 mb-2">
            <hr>
            <h3>
              <i  aria-hidden="true" class="fad fa-money-check twoToneRedOrange fa-1-2x titleIcon"></i>
              <span [translate]="'renting.commercialOffer'"></span>
            </h3>
            <div class="row">
              <div class="col-12">
                <span class="font-weight-bold" [translate]="'rentinglist.duration'"></span>
                <span class="font-weight-bold"> : </span>
                <!--<span *ngIf="info.rentingDuration == 3" [translate]="'renting.3yearsduration'"></span>-->
                <span *ngIf="info.rentingDuration == 5" [translate]="'renting.5yearsduration'"></span>
              </div>
            </div>
          </div>

        </div>
        <!-- Commande de produits -->
        <div class="col-xl-6 col-lg-6">
          <div class="col-12 mb-2">
            <hr>
            <h3>
              <i  aria-hidden="true" class="fad fa-box-full twoToneRed fa-1-2x titleIcon"></i>
              <span class="breakWord" [translate]="'rentinglist.order'"></span>
            </h3>
            <div class="mt-3">
              <table class="table-bordered tableOrder">
                <caption></caption>
                <thead>
                  <tr class="text-center">
                    <th scope="col" [translate]="'shoppingcart.designation'"> </th>
                    <th scope="col" [translate]="'renting.rentingPrix'"> </th>
                    <th scope="col" [translate]="'shoppingcart.quantite'"> </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>IxellColorConnect</td>
                    <td class="text-center">-</td>
                    <td class="text-center">1</td>
                  </tr>
                  <tr *ngIf="!isSupport">
                    <td [translate]="'renting.baseSupport'"></td>
                    <td class="text-center">-</td>
                    <td class="text-center">1</td>
                  </tr>
                  <tr *ngFor="let order of orderLight">
                    <td>
                      {{order.labelP}}
                    </td>
                    <td class="text-center">
                      {{order.amountP | number : '1.2-2'}} €
                    </td>
                    <td class="text-center">
                      {{order.qty}}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3"> <span class="font-weight-bold" [translate]="'shoppingcart.total'"> </span>: {{totalAmountOrder | number : '1.2-2'}} €</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
